import ActivityIndicator from 'components/ActivityIndicator';
import React, { ReactNode } from 'react';
import { Option } from 'react-multi-select-component';

interface IDefaultItemRendererProps {
    checked: boolean;
    option: any;
    disabled?: boolean;
    onClick: any;
}

const DefaultItemRenderer = ({ checked, option, onClick, disabled }: IDefaultItemRendererProps) => (
    <div className={`item-renderer ${disabled ? 'disabled' : ''}`}>
        <input type="checkbox" onChange={onClick} checked={checked} tabIndex={-1} disabled={disabled} />
        <div className="item-renderer-test">
            <ActivityIndicator type={option.value} />
            {option.label}
        </div>
    </div>
);

export default DefaultItemRenderer;
